<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="5"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Submenu
      v-if="!Bignav"
      :Info="SubInfo"
      :DividNum="4"
      :BGImgUrl="'sbg0101.png'"
      :Submenu="Submenu"
      v-on:cellback="Navgo"
      style="z-index: -6"
    ></Submenu>
    <router-view />
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Submenu from "@/components/Submenu.vue";
export default {
  name: "About",
  data() {
    return {
      Bignav: false,
      SubInfo: {
        title: "關於我們",
        body: ""
      },
      Submenu: [
        {
          id: "01",
          text: "我們的願景"
        },
        {
          id: "02",
          text: "empowerME <br>患者抗癌計畫"
        },
        {
          id: "03",
          text: "經營管理合作與 <br>諮詢顧問服務"
        }
      ]
    };
  },
  components: {
    Back,
    Submenu,
    Bigmenu
  },
  methods: {
    Navgo(v) {
      switch (v) {
        case 0:
          this.$router.push("/A01");
          break;
        case 1:
          this.$router.push("/A02");
          break;
        case 2:
          this.$router.push("/A03");
          break;
      }
    },
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;

}
</style>
